import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { setNormalHoursFormSchema } from './set-normal-hours-form.schema';
import { useEffect } from 'react';

export const useSetNormalHoursForm = selectedEvent => {
  const form = useForm({
    resolver: yupResolver(setNormalHoursFormSchema),
    defaultValues: setNormalHoursFormSchema.cast(selectedEvent ?? {}),
  });

  const { reset } = form;
  useEffect(() => {
    reset(selectedEvent ?? {});
  }, [reset, selectedEvent]);

  return { form };
};
